import { Redirect, Route } from "wouter";
import { ReactNode } from "react";
import { useStore } from "src/store/store";

interface ProtectedRouteProps {
	allowedRoles: ("admin" | "doctor" | "user" | "broker")[];
	children: ReactNode;
	path: string;
}

export const ProtectedRoute = ({ allowedRoles, children, path }: ProtectedRouteProps) => {
	const { user } = useStore();

	// Handle guest routes (for non-authenticated users)
	if (!user) {
		return <Redirect to="/login" replace />;
	}

	// Determine user role
	const role = user.admin
		? "admin"
		: user.issuingDoctor || user.recommendingDoctor
		? "doctor"
		: user.broker
		? "broker"
		: "user";

	console.log("allowedRoles", allowedRoles, role);

	if (!allowedRoles.includes(role)) {
		return <Redirect to="/" replace />;
	}

	return <Route path={path}>{children}</Route>;
};
